import type { NavSectionData } from '@layouts/dashboard/types';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { NavContent } from '@layouts/dashboard/components/nav-content';

import { Sheet, SheetTitle, SheetContent, SheetDescription } from '@shared/components/ui/sheet';

type Props = {
  data: NavSectionData[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/** Side menu as a left sheet on phones and tablets (< lg). Closes on navigation. */
export const NavMobile = ({ data, open, onOpenChange }: Props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    onOpenChange(false);
    // Only react to the route change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Sheet onOpenChange={onOpenChange} open={open}>
      <SheetContent className="w-72 max-w-none bg-card" showCloseButton={false} side="left">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <SheetDescription className="sr-only">Navigation de l&apos;application</SheetDescription>
        <NavContent data={data} />
      </SheetContent>
    </Sheet>
  );
};
